// third-party
import axios from "axios";

// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import { setCookie } from "../utils";
import courseData from "../data/course/CourseData.json";

//Reading  environment variables Here
const SF_BASE_URL = process.env.REACT_APP_SF_API_BASE_URL;
const COOKIE_FOR_USER_KEY = process.env.REACT_APP_COOKIE_FOR_USER_KEY;
const RAZORPAY_FUNCTION_URL = process.env.REACT_APP_FIREBASE_RAZORPAY_FUNCTION_URL;
// Constant funciton

// Function to get the access token
async function getAccessTokenV2() {
  try {
    // Reading Environnment variables start
    const grantType = process.env.REACT_APP_SF_GRANT_TYPE;
    const clientId = process.env.REACT_APP_SF_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_SF_CLIENT_SECRET;

    // Assigning the credentials to the endpoint variable of org. 22 start
    // const userName = process.env.REACT_APP_SF_USER_NAME;
    // const Password = process.env.REACT_APP_SF_PASSWORD;
    // end

    // Reading Environnment variables End

    // Assigning the credentials to the endpoint variable of org. 22 start
    //  let endpoint = SF_BASE_URL + "/services/oauth2/token?grant_type=" + grantType + "&client_id=" + clientId + "&client_secret=" + clientSecret + "&username=" + userName + "&password=" + Password;
    // Assigning the credentials to the endpoint variable of org. 22 end

    // Assigning the credentials to the endpoint variable of production org. start
    let endpoint =
      SF_BASE_URL +
      "/services/oauth2/token?grant_type=" +
      grantType +
      "&client_id=" +
      clientId +
      "&client_secret=" +
      clientSecret;
    // Assigning the credentials to the endpoint variable of production org. End
    // posting endpoint to get access token

    let response = await axios.post(endpoint);
    return response && response.data && response.data.access_token;
  } catch (error) {
    console.log("50 : salesforce_api_context : Error while getting an Access token::", error && JSON.stringify(error));
    // Showing the toast message on getting access token unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

/**
 * Validate reCAPTCHA v3 and get token
 * @returns {Promise<string>} reCAPTCHA token
 */
export async function validateCaptcha(action = "submit") {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!siteKey) {
    throw new Error("Missing reCAPTCHA site key");
  }

  // Wait until window.grecaptcha is available
  if (!window.grecaptcha || !window.grecaptcha.execute || !window.grecaptcha.ready) {
    await new Promise((resolve) => {
      const check = setInterval(() => {
        if (window.grecaptcha && window.grecaptcha.execute && window.grecaptcha.ready) {
          clearInterval(check);
          resolve();
        }
      }, 100);
    });
  }

  // Execute reCAPTCHA
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action })
        .then(resolve)
        .catch((error) => {
          console.error("95 : order_context : Error executing reCAPTCHA:", error && JSON.stringify(error));
          reject(error);
        });
    });
  });
}

async function getAccessToken() {
  try {

    // console.log("93=>REACT_APP_FIREBASE_FUNCTION_URL", process.env.REACT_APP_FIREBASE_FUNCTION_URL);

    const response = await fetch(process.env.REACT_APP_FIREBASE_FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_FIREBASE_FUNCTION_REQUEST_KEY
      },
    });

    const data = await response.json();
    // console.log("salesforce_api_context::getAccessToken::Result:", data);
    return data?.access_token || null;
  } catch (error) {
    console.log("118 : order_context : Error while getting an Access token::", error && JSON.stringify(error));
    // Showing the toast message on getting access token unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get all courses
export async function getCoursesV2() {
  try {
    // Getting the access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const config = {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    // Calling API to get the courses
    // services/apexrest/course?collectionId=courses
    const response = await axios.get(SF_BASE_URL + '/services/apexrest/course?collectionId=courses', config); // Date: 31/07/2024

    // Showing the toast message on course loading successfully
    // showToast("success", "Courses have been loaded successfully.", true, "bottom-right", false, true, 5000);

    return response && response.data && response.data.length && response.data; // Date: 31/07/2024
    // return courseData;
  } catch (error) {
    console.log("155 : salesforce_api_context : Error while getting courses::", error && JSON.stringify(error));

    // Showing the toast message on getting course unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get all the courses v2
export async function getCourses(filters) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = {
      collectionId: "courses",
      filters: filters,
      offset: 0
    };
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint = SF_BASE_URL + "/services/apexrest/course/v1/search";

      // Calling API to get the courses
      let response = await axios.post(endpoint, body, configs);
      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("198 : salesforce_api_context : Error while getting courses from API ::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("202 : salesforce_api_context : Error in getCoursesV2::", error && JSON.stringify(error));

    // Showing the toast message on getting courses unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to put(update) course like
export async function putCourseLike(courseId, likes) {

  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [{ likes }];
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/course?collectionId=courses&documentId=${courseId}`;

      // Calling API to put course like
      let response = await axios.put(endpoint, body, configs);
      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("243 : salesforce_api_context : Error while liking the course:: ", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("247 : salesforce_api_context : Error in putCourseLike:: ", error && JSON.stringify(error));

    // Showing the toast message on updating like to the course unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get course comments
export async function getCourseComments() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/coursecomments?collectionId=coursecomments`;

      // Calling API to get course comment
      let response = await axios.get(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("287 : salesforce_api_context : Error on getting course comments::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("291 : salesforce_api_context : Error in getCourseComments::", error && JSON.stringify(error));

    // Showing the toast message on getting course comments unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get course comments by courseId
export async function getCourseCommentsByCourseId(courseId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = {
      collectionId: "coursecomments",
      filters: [
        {
          field: "courseId",
          operator: "EQUAL",
          value: courseId,
        },
      ],
      offset: 0,
    };
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL + "/services/apexrest/coursecomments/v1/search";

      // Calling API to get course comments by courseId
      let response = await axios.post(endpoint, body, configs);
      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("341 : salesforce_api_context : Error while getting filtered course comments::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("345 : salesforce_api_context : Error in getCourseCommentsByCourseId::", error && JSON.stringify(error));

    // Showing the toast message on getting course comment by courseId unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to post(add) course comment
export async function postCourseComment(comment) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [comment];

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        "/services/apexrest/coursecomments?collectionId=coursecomments";

      // Calling API to post the course comment
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("388 : salesforce_api_context : Error while adding comments to course::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("392 : salesforce_api_context : Error in postCourseComment::", error && JSON.stringify(error));

    // Showing the toast message on adding course comment unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to put(update) course comment
export async function putCourseComment(commentId, comment, userId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [comment];
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/coursecomments?collectionId=coursecomments&documentId=${commentId}&userId=${userId}`;

      // Calling API to put the course comment
      let response = await axios.put(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("434 : salesforce_api_context : Error while updating comments in course::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("438 : salesforce_api_context : Error in putCourseComment::", error && JSON.stringify(error));

    // Showing the toast message on updating course comment unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to put(update) course comment like
export async function putCourseCommentLike(commentId, comment) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [comment];

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/coursecomments?collectionId=coursecomments&documentId=${commentId}`;

      // Calling API to put course comment like
      let response = await axios.put(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("481 : salesforce_api_context : Error while update course comment like::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("485 : salesforce_api_context : Error in putCourseCommentLike::", error && JSON.stringify(error));

    // Showing the toast message on updating course comment like unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to delete the course comment
export async function delCourseComment(commentId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/coursecomments?collectionId=coursecomments&documentId=${commentId}`;

      // Calling API to delete course comment
      let response = await axios.delete(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("525 : salesforce_api_context : Error while deleting course comment::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("529 : salesforce_api_context : Error in delCourseComment::", error && JSON.stringify(error));

    // Showing the toast message on delete course comment unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get all categories
export async function getCategories() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL + "/services/apexrest/category?collectionId=categories";

      // Calling API to get all Categories
      let response = await axios.get(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("568 : salesforce_api_context : Error while getting categories::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("572 : salesforce_api_context : Error in getCategories::", error && JSON.stringify(error));

    // Showing the toast message on getting catgories unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get all blogs
export async function getBlog() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint = SF_BASE_URL + "/services/apexrest/blog?collectionId=blogs";

      // Calling API to get the blogs
      let response = await axios.get(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("610 : salesforce_api_context : Error while getting blogs::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("614 : salesforce_api_context : Error in getBlog::", error && JSON.stringify(error));

    // Showing the toast message on getting blogs unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get all blogs v2
export async function getBlogsV2(filters) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = {
      collectionId: "blogs",
      filters: filters,
      offset: 0,
      limitClause: 40,
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint = SF_BASE_URL + "/services/apexrest/blog/v1/search";

      // Calling API to get blogs
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("660 : salesforce_api_context : Error while getting blog V2::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("664 : salesforce_api_context : Error in getBlogsV2::", error && JSON.stringify(error));

    // Showing the toast message on getting blogs unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to put(update) blog like
export async function putBlogLike(blogId, likes) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [{ likes }];

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/blog?collectionId=blogs&documentId=${blogId}`;

      // Calling API to put the blog like
      let response = await axios.put(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("707 : salesforce_api_context : Error while liking the blog : ", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("711 : salesforce_api_context : Error in putBlogLike : ", error && JSON.stringify(error));

    // Showing the toast message on update blog like unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get blog comment by blogid
export async function getBlogCommentsByBlogId(blogId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = {
      collectionId: "blogcomments",
      filters: [
        {
          field: "blogId",
          operator: "EQUAL",
          value: blogId,
        },
      ],
      offset: 0,
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint = SF_BASE_URL + "/services/apexrest/blogcomments/v1/search";

      // Calling API to get blog comments by blogId
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("762 : salesforce_api_context : Error while geting comments of this blog::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("766 : salesforce_api_context : Error in getBlogCommentsByBlogId::", error && JSON.stringify(error));

    // Showing the toast message on getting blog comment by blogId unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to post(add) blog comment
export async function postBlogComment(comment) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [comment];
    // console.log("body cmt => ", body);

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/blogcomments?collectionId=blogcomments`;

      // Calling API to post blog comment
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("810 : salesforce_api_context : Error while adding comment to the blog::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("814 : salesforce_api_context : Error in postBlogComment::", error && JSON.stringify(error));
    // Showing the toast message on adding blog comments unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to put(update) blog comment
export async function putBlogComment(commentId, comment, userId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [comment];

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/blogcomments?collectionId=blogcomments&documentId=${commentId}&userId=${userId}`;

      // Calling API to put blog comment
      let response = await axios.put(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("856 : salesforce_api_context : Error while updating blog comment::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("860 : salesforce_api_context : Error in putBlogComment::", error && JSON.stringify(error));

    // Showing the toast message on updating blog comment unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to put(update) blog comment like
export async function putBlogCommentlike(commentId, comment) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [comment];

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/blogcomments?collectionId=blogcomments&documentId=${commentId}`;

      // Calling API to put blog comment like
      let response = await axios.put(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("903 : salesforce_api_context : Error while updating blog comment like::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("907 : salesforce_api_context : Error in putBlogCommentlike::", error && JSON.stringify(error));

    // Showing the toast message on updating blog comment like unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Funtion to delete blog comment
export async function delBlogComment(blogId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/course?collectionId=blogcomments&documentId=${blogId}`;

      // Calling API to delete blog comment
      let response = await axios.delete(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("947 : salesforce_api_context : Error while deleting comment::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("951 : salesforce_api_context : Error in delBlogComment::", error && JSON.stringify(error));

    // Showing the toast message on delete blog comment unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get blog comments
export async function getBlogComments() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        `/services/apexrest/blogcomments?collectionId=blogcomments`;

      // Calling API to get the blog comments
      let response = await axios.get(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("990 : salesforce_api_context : Error on get course comments::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("994 : salesforce_api_context : Error in getBlogComments", error && JSON.stringify(error));

    // Showing the toast message on getting blog commments unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get testimonials
export async function getTestimonial() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        // "/services/apexrest/testimonial?collectionId=testimonials";
        "/services/apexrest/testimonial/v1/search";

      const body = {
        collectionId: "testimonials",
        filters: [],
        offset: 0
      };
      // Calling API to get the Testimonials
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1040 : salesforce_api_context : Error while getting testimonials::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1044 : salesforce_api_context : Error in getTestimonial::", error && JSON.stringify(error));

    // Showing the toast message on getting testimonials unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to post(add) enquiry
export async function postSubmitEnquiry(enquiryObj) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [enquiryObj];
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint = SF_BASE_URL + "/services/apexrest/enquiry";

      // Calling API to post user enquiry
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1084 : salesforce_api_context : Error while posting enquiry::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1088 : salesforce_api_context : Error in postSubmitEnquiry::", error && JSON.stringify(error));

    // Showing the toast message on submitting enquiry unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to post(add) user reaction
export async function postUserReactions(payload) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = payload;
    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        "/services/apexrest/user-reactions/?collectionId=userreactions";

      // Calling API to post user reaciton
      let response = await axios.post(endpoint, body, configs);
      return response && response.data ? response.data : response;
    } catch (error) {
      console.log(
        "1130 : salesforce_api_context : Error while posting user reactions::",
        error && JSON.stringify(error)
      );
      throw error;
    }
  } catch (error) {
    console.log("1136 : salesforce_api_context : Error in postUserReactions::", error && JSON.stringify(error));

    // Showing the toast message on adding user reaction unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );

    throw error;
  }
}

// Function to get user reaction by parentId
export async function getUserReactionsByParentId(parentId) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // Creating the header and assigning the access token to it
    const config = {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };

    // Calling API to get user reaction by parentId
    const response = await axios.get(
      SF_BASE_URL +
      // `/services/apexrest/course-user-reactions/?&collectionId=courseuserreactions&courseId=${courseId}`, changed By Longswitch Team
      `/services/apexrest/user-reactions/?collectionId=userreactions&parentId=${parentId}`, //commented by Longswitch Team on 17/03/2025
      // `/services/apexrest/user-reactions/?collectionId=userreactions&parentId=${parentId}`, ///Added production org url by Longswitch Team
      config
    );

    // Showing the toast message on course loading successfully
    // showToast("success", "Courses loaded successfully", true, "bottom-right", false, true, 5000);

    return response && response.data && response.data.length && response.data;
  } catch (error) {
    console.log("1180 : salesforce_api_context : Error in getUserReactionsByParentId::", error && JSON.stringify(error));

    // Showing the toast message on getting user reaction by parentId unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get instructor
export async function getInstructor() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        "/services/apexrest/instructordata/?collectionId=instructordata";

      // Calling API to get the Instructor
      let response = await axios.get(endpoint, configs);

      return response && response.data && response.data.length
        ? response.data
        : response.data;
    } catch (error) {
      console.log("1222 : salesforce_api_context : Error while getting instructor detail::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1226 : salesforce_api_context : Error in getInstructor::", error && JSON.stringify(error));

    // Showing the toast message on getting instructor unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Funciton to signIn user
export async function signInV1(payload) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // Creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = payload;

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL + "/services/apexrest/loginUser?collectionId=users";

      // Calling API to get the user Login
      let response = await axios.post(endpoint, body, configs);

      // Setting cookie
      if (response) {
        const expirationLimit = 24 * 60 * 60 * 1000;
        const expirationTime = new Date(Date.now() + expirationLimit);
        const COOKIE_NAME = `${COOKIE_FOR_USER_KEY +
          (response && response?.data && response?.data?.data
            ? response?.data?.data?.userRecordId
            : "defaultCookieName")
          }`;
        setCookie(
          COOKIE_NAME,
          JSON.stringify(response?.data?.data),
          expirationTime
        );
      }
      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1283 : salesforce_api_context : Error while signing in::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1287 : salesforce_api_context : Error in Sign in::", error && JSON.stringify(error));

    // Showing the toast message on logging unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

export async function signIn(payload) {
  try {
    // Reading environment variable start
    const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
    const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
    // Reading environment variable end

    try {
      if (!xApiKey) return;

      // creating the header
      const configs = {
        withCredentials: true,
        headers: {
          "x-api-key": xApiKey,
        },
      };

      // Assigning the credentials to the endpoint variable
      let endpoint = baseURL + "/api/user/login";

      // Calling API to get the user Login
      let response = await axios.post(endpoint, payload, configs);

      // Setting cookie
      // if (response) {
      // const expirationLimit = 24 * 60 * 60 * 1000;
      // const expirationTime = new Date(Date.now() + expirationLimit);
      // const COOKIE_NAME = `${COOKIE_FOR_USER_KEY +
      //   (response && response?.data && response?.data?.data
      //     ? response?.data?.data?.userRecordId
      //     : "defaultCookieName")
      //   }`;
      // const COOKIE_NAME = `${COOKIE_FOR_USER_KEY}`;
      // setCookie(
      //   COOKIE_NAME,
      //   JSON.stringify(response?.data?.data?.token),
      //   expirationTime
      // );
      // }
      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1283 : salesforce_api_context : Error while signing in::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1287 : salesforce_api_context : Error in Sign in::", error && JSON.stringify(error));

    // Showing the toast message on logging unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to signUp new user
export async function signUpV1(payload) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // Creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = [payload];

    // Assigning the credentials to the endpoint variable
    let endpoint = SF_BASE_URL + "/services/apexrest/user?collectionId=users";

    // Calling API to post new user data
    let response = await axios.post(endpoint, body, configs);
    const data = response?.data;

    // ✅ Check for backend-reported error even if HTTP was OK
    if (data.statusCode !== 200 && data.statusCode !== 201) {
      const errorMessage =
        data?.failures?.errors?.[0]?.message || "Signup failed";
      const error = new Error(errorMessage);
      error.responseData = data;
      throw error;
    }

    return data;
  } catch (error) {
    console.log("1337 : salesforce_api_context : Error in SignUp::", error && JSON.stringify(error));

    // Showing the toast message on post user unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

export async function signUp(payload) {
  // Reading environment variable start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading environment variable end
  try {
    if (!xApiKey) return;

    // creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpoint = baseURL + "/api/user/register";

    // Calling API to get the user Login
    let response = await axios.post(endpoint, payload, configs);

    const data = response?.data;

    // Check for backend-reported error even if HTTP was OK
    // if (data.statusCode !== 200 && data.statusCode !== 201) {
    //   const errorMessage =
    //     data?.failures?.errors?.[0]?.message || "Signup failed";
    //   const error = new Error(errorMessage);
    //   error.responseData = data;
    //   throw error;
    // }

    return data;
  } catch (error) {
    console.log("1337 : salesforce_api_context : Error in SignUp::", error && JSON.stringify(error));

    // Showing the toast message on post user unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

export async function signOut(payload) {
  // Reading environment variable start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading environment variable end

  try {
    // Creating the header and assigning the access token to it
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    if (!xApiKey) return;

    // Assigning the credentials to the endpoint variable
    let endpoint = baseURL + "/api/user/logout";

    // Calling API to get the user Login
    let response = await axios.post(endpoint, payload, configs);

    const data = response?.data;

    // ✅ Check for backend-reported error even if HTTP was OK
    // if (data.statusCode !== 200 && data.statusCode !== 201) {
    //   const errorMessage =
    //     data?.failures?.errors?.[0]?.message || "Signup failed";
    //   const error = new Error(errorMessage);
    //   error.responseData = data;
    //   throw error;
    // }

    return data;
  } catch (error) {
    console.log("1504 : salesforce_api_context : Error in SignOut::", error && JSON.stringify(error));

    // Showing the toast message on post user unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

export const checkSignIn = async (endpoint) => {
  // Reading Environnment variables start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading Environnment variables end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // Creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to get the Achievements
    let response = await axios.get(endpointUrl, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};

export const forgotPass = async (endpoint, payload) => {
  // Reading Environnment variables start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading Environnment variables end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // Creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to get the Achievements
    let response = await axios.post(endpointUrl, payload, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};

export const resetPass = async (endpoint, payload) => {
  // Reading Environnment variables start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading Environnment variables end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // Creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to get the Achievements
    let response = await axios.post(endpointUrl, payload, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};

export const checkUsername = async (endpoint) => {
  // Reading Environnment variables start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading Environnment variables end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // Creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to get the Achievements
    let response = await axios.get(endpointUrl, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};

// Function to post(add) testimonial
export async function postTestimonial(payload) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Giving data to the body
    const body = payload;

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        "/services/apexrest/testimonial?collectionId=testimonials";

      // Calling API to post testimonial
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1380 : salesforce_api_context : Error while posting testimonial::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1384 : salesforce_api_context : Error in postTestimonial::", error && JSON.stringify(error));

    // Showing the toast message on adding testimonial unsuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get orders data
export async function getAllOrders() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        // "/services/apexrest/testimonial?collectionId=testimonials";
        "/services/apexrest/order?collectionId=orders";
      // Calling API to get the orders
      let response = await axios.get(endpoint, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1435 : salesforce_api_context : Error while getting all orders::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1439 : salesforce_api_context : Error in orders::", error && JSON.stringify(error));

    // Showing the toast message on getting orders unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

export async function getOrders(id) {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        // "/services/apexrest/testimonial?collectionId=testimonials";
        "/services/apexrest/order/v1/search";

      const body = {
        collectionId: "orders",
        filters: [
          {
            field: "customerId",
            operator: "EQUAL",
            value: id
          }
        ],
      };
      // Calling API to get the orders
      let response = await axios.post(endpoint, body, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1435 : salesforce_api_context : Error while getting orders::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1439 : salesforce_api_context : Error in orders::", error && JSON.stringify(error));

    // Showing the toast message on getting orders unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get orders data
export async function postOrders(body) {
  try {

    try {

      // Getting an access token
      const accessToken = await getAccessToken();

      // creating the header and assigning the access token to it
      const configs = {
        headers: {
          Authorization: `${accessToken}`,
        },
      };
      // Assigning the credentials to the endpoint variable
      let endpoint = RAZORPAY_FUNCTION_URL;

      // Calling API to create the orders
      let response = await axios.post(endpoint, body, configs);

      return response && response.data?.response?.success === true ? response.data?.response : response;
    } catch (error) {
      console.log("1478 : salesforce_api_context : Error while creating orders::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1482 : salesforce_api_context : Error in createOrders ::", error && JSON.stringify(error));

    // Showing the toast message on getting orders unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to download the eBook
export async function postDownloadEbook(data) {
  try {

    let endpoint = RAZORPAY_FUNCTION_URL;

    const apiRes = await fetch(
      endpoint,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-lsa-download-pdf": "true"
        },
        body: JSON.stringify({ productId: data?.productId, paymentId: data?.paymentId })
      }
    );
    // console.log("1559 : api_context : ", apiRes);
    if (!apiRes.ok) {
      const text = await apiRes.text();
      console.error("Download failed:", text);
      alert("Unauthorized or failed to download");
      return;
    }

    // Read PDF as blob
    const blob = await apiRes.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${data?.productName + " " + process.env.REACT_APP_LONGSWITCH_ACADEMY_EBOOK_SUFFIX || process.env.REACT_APP_LONGSWITCH_ACADEMY_EBOOK_SUFFIX}.zip`;
    document.body.appendChild(link);

    try {
      link.click();
    } catch (e) {
      console.warn("Auto-download failed, showing fallback link");
    }
    link.remove();
    // Clean up
    window.URL.revokeObjectURL(url);

    return "success";
  } catch (error) {
    console.log("1544 : salesforce_api_context : Error in downloadEbook ::", error && JSON.stringify(error));

    // Showing the toast message on getting orders unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get products data
export async function getProducts() {
  try {
    // Getting an access token
    const accessToken = await getAccessToken();

    // creating the header and assigning the access token to it
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    try {
      // Assigning the credentials to the endpoint variable
      let endpoint =
        SF_BASE_URL +
        "/services/apexrest/product/v1/search?collectionId=products";

      const requestBody = {
        "collectionId": "products",
        "filters": [
          {
            "field": "isActive",
            "operator": "EQUAL",
            "value": true
          }
        ],
        "offset": 0
      };
      // Calling API to get the products
      let response = await axios.post(endpoint, requestBody, configs);

      return response && response.data ? response.data : response;
    } catch (error) {
      console.log("1595 : salesforce_api_context : Error while getting products::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1599 : salesforce_api_context : Error in products::", error && JSON.stringify(error));

    // Showing the toast message on getting products unSuccessfully
    showToast(
      "error",
      error && error.message ? error.message : "An error occurred",
      true,
      "bottom-right",
      false,
      true,
      5000
    );
    throw error;
  }
}

// Function to get Stats data
export async function getStats() {
  try {
    // Getting an access token    
    const accessToken = await getAccessToken();
    // creating the header and assigning the access token to it    
    const configs = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    try {
      // Assigning the credentials to the endpoint variable      
      let endpoint = SF_BASE_URL + "/services/apexrest/instructordata/?collectionId= here_we_have_to_add_the_stats_collection_ID"; // Need to change the collectionId for the stats      
      // Calling API to get the Stats
      let response = await axios.get(endpoint, configs);
      return response && response.data && response.data.length
        ? response.data
        : response.data;
    } catch (error) {
      console.log("1642 : salesforce_api_context : Error while getting stats::", error && JSON.stringify(error));
      throw error;
    }
  } catch (error) {
    console.log("1646 : salesforce_api_context : Error in getStats::", error && JSON.stringify(error));
    // Showing the toast message on getting stats data unSuccessfully    
    showToast("error", error && error.message ? error.message : "An error occurred", true, "bottom-right", false, true, 5000);
    throw error;
  }
}

// Get data dynamically from fo backend
export const fetchData = async (endpoint) => {
  // Reading Environnment variables start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading Environnment variables end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // Creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to get the Achievements
    let response = await axios.get(endpointUrl, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};

export const postData = async (endpoint, payload) => {
  // Reading environment variable start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading environment variable end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to post contact enquiry
    let response = await axios.post(endpointUrl, payload, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};

export const updateData = async (endpoint, payload) => {
  // Reading environment variable start
  const baseURL = process.env.REACT_APP_FO_API_BASE_URL;
  const xApiKey = process.env.REACT_APP_FO_X_API_KEY;
  // Reading environment variable end

  // eslint-disable-next-line no-useless-catch
  try {
    if (!xApiKey) return;

    // creating the header
    const configs = {
      withCredentials: true,
      headers: {
        "x-api-key": xApiKey,
      },
    };

    // Assigning the credentials to the endpoint variable
    let endpointUrl = `${baseURL}` + endpoint;

    // Calling API to post contact enquiry
    let response = await axios.put(endpointUrl, payload, configs);

    return response && response.data ? response.data : response;
  } catch (error) {
    throw error;
  }
};